import { render, staticRenderFns } from "./SavePromptModal.vue?vue&type=template&id=31fbfe39&scoped=true"
import script from "./SavePromptModal.vue?vue&type=script&lang=js"
export * from "./SavePromptModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31fbfe39",
  null
  
)

export default component.exports